export const WEEKLY = 52;
export const BI_WEEKLY = 26;
export const SEMI_MONTHLY = 24;
export const MONTHLY = 12;

export default {
    WEEKLY,
    BI_WEEKLY,
    SEMI_MONTHLY,
    MONTHLY,
};
